export const SIDEBAR_LOCALE = {
    sidebar: 'Detail',
};
